import StateControllerBase from "@/store/stateControllerBase";
import { setLoadingState } from "@/store/setLoadingState";

import AxiosController from "@/api/axiosController";
const axiosController = new AxiosController();

class Actions extends StateControllerBase {
  setDataLoading({ commit }, dataLoading) {
    commit("setDataLoading", dataLoading);
  }

  @setLoadingState
  async getStackingPoolNoPagination({ commit }) {
    const params = {
      pagination: false,
      type: "token_capital_buy",
      applicationType: "stakingPool",
      hasWithdrawalDate: false
    };
    const resp = await axiosController.getStackingPool(params);
    commit("setMyStackingOrders", resp?.data ?? []);
    return resp;
  }

}
export default (new Actions).asPlainObject();